import LegalDocument from "./LegalDocument";

export default function Terms() {
  return <LegalDocument kind="terms" />;
}
